import client from '../../client'

export const onboarding = () => client.patch('/v1/users/me/accept-onboarding')
